module.exports = __webpack_public_path__ + "img/pr-8.1a6c7651.png";